<template>
  <div>
    <v-text-field
      prepend-icon="attach_file"
      placeholder="Files upload"
      :value="value"
      clearable
      readonly
      hide-details
      @click:prepend="targetClick"
      @click:clear="reset"
      @click="targetClick"
    ></v-text-field>
    <input
      v-show="false"
      v-bind="$attrs"
      v-on="localListeners"
      ref="files"
      type="file"
      multiple
    >
  </div>
</template>

<script>

export default {
  name: 'filesUploader',
  inheritAttrs: false,
  props: {
    value: String,
  },
  computed: {
    localListeners() {
      return {
        ...this.$listeners,
        change: event => this.$emit('input', Array.from(event.target.files)),
        focus: () => this.$emit('focus'),
        blur: () => this.$emit('blur'),
      };
    },
  },
  methods: {
    reset() {
      this.$refs.files.value = '';
      this.$emit('input', []);
    },
    targetClick() {
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': true,
      });
      this.$refs.files.dispatchEvent(event);
    },
  },
};
</script>
